import * as React from "react";
import {Tabs} from "shared/controls/Tabs/Tabs";
import 'shared/styles/bootstrapminimal.scss';
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faAmbulance} from "@fortawesome/free-solid-svg-icons/faAmbulance";
import {faLifeRing} from "@fortawesome/free-regular-svg-icons/faLifeRing";
import {faQuestion} from "@fortawesome/free-solid-svg-icons/faQuestion";
import {Support} from "./Tabs/Support/Support";
import {PreSaleQuestion} from "./Tabs/PreSaleQuestion/PreSaleQuestion";

export class FormApp extends React.Component<FormAppProps, FormAppState> {
    static defaultProps: Partial<FormAppProps> = {};

    constructor(props: FormAppProps) {
        super(props);
        this.state = {
            TabOpen:'support'
        };
    }

    public render() {
        return (
            <div className={'rednao'}>
                <Tabs TabToOpen={this.state.TabOpen} TabToOpenChanged={x=>this.setState({TabOpen:x})}>
                    <Tabs.Item Title={'Contact Support'} Id={'support'} Icon={<FontAwesomeIcon icon={faLifeRing}/>}>
                        <Support/>
                    </Tabs.Item>
                    <Tabs.Item Title={'Presale Question'} Id={'presale'} Icon={<FontAwesomeIcon icon={faQuestion}/>}>
                        <PreSaleQuestion GoToContactForm={()=>this.setState({TabOpen:'support'})}/>
                    </Tabs.Item>
                </Tabs>
            </div>

        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormAppProps {

}

interface FormAppState {
    TabOpen:string;
}

//#endregion "My Region"